import LineGradient from "../components/LineGradient";
import { motion } from "framer-motion";

const container = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.2,
    },
  },
};

const projectVariant = {
  hidden: { opacity: 0, scale: 0.8 },
  visible: { opacity: 1, scale: 1 },
};

const Project = ({ title, source, live, details }) => {
  const overlayStyles = `absolute  w-full opacity-0 hover:opacity-90 transition duration-500
    bg-grey z-30 flex flex-col justify-center items-center text-center p-20 text-deep-blue`;
  const projectTitle = title.split(" ").join("-").toLowerCase();

  return (
    <motion.div variants={projectVariant} className="relative" style={{ border: '2px solid black' }}>
      <div className={overlayStyles}>
        <p className="text-2xl font-playfair">{title}</p>
        <p className="mt-7">
          {details}
        </p>
      </div>
      <img src={`../assets/${projectTitle}.jpeg`} alt={projectTitle} />
      <div style={{ backgroundColor: "rgb(220, 68, 146)", display: 'flex', justifyContent: 'space-between' }}>
        <button style={{ fontFamily: "Open Sans, sans-serif", margin: '1rem', backgroundColor: '#010026', height: '2.7rem', width: '8rem', borderRadius: '10px' }} onClick={() => { window.open(source, "_blank") }}> Source code</button>
        <button style={{ fontFamily: "Open Sans, sans-serif", margin: '1rem', backgroundColor: '#010026', height: '2.7rem', width: '8rem', borderRadius: '10px' }} onClick={() => { window.open(live, "_blank") }}>live View</button></div>
    </motion.div>
  );
};

const Projects = () => {
  return (
    <section id="projects" className="pt-48 pb-48">
      {/* HEADINGS */}
      <motion.div
        className="md:w-2/5 mx-auto text-center"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.5 }}
        transition={{ duration: 0.5 }}
        variants={{
          hidden: { opacity: 0, y: -50 },
          visible: { opacity: 1, y: 0 },
        }}
      >
        <div>
          <p className="font-playfair font-semibold text-4xl">
            <span className="text-red">PRO</span>JECTS
          </p>
          <div className="flex justify-center mt-5">
            <LineGradient width="w-2/3" />
          </div>
        </div>
        <p className="mt-10 mb-10">
          Here are Some of My Best projects, you can click any of them to get live view of them and Source Code on Github. These in clude Web Development, android Development and Machine Learning Projects.
        </p>
      </motion.div>

      {/* PROJECTS */}
      <div className="flex justify-center">
        <motion.div
          className="sm:grid sm:grid-cols-3"
          variants={container}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.2 }}
        >
          {/* ROW 1 */}
          <div
            className="flex justify-center text-center items-center p-10 bg-red
              max-w-[403px] max-h-[476px] text-2xl font-playfair font-semibold"
          >
            BEAUTIFUL USER INTERFACES
          </div>
          <Project title="Project 1" source='https://github.com/NamandeepNegi/e-commerce-application' live='https://e-shop-cart.onrender.com/' details='e-commerce application MERN stack' />
          <Project title="Project 2" source='https://github.com/NamandeepNegi/Dashboard-MERN' live='https://dashboard-frontend-f885.onrender.com/' details='Dashboard web application application MERN stack' />

          {/* ROW 2 */}
          <Project title="Project 3" source='https://github.com/NamandeepNegi/cars-nextjs-typescript' live='https://cars-nextjs-typescript.vercel.app/' details='Next.js TypeScript application car showcase' />
          <Project title="Project 4" source='https://github.com/NamandeepNegi/pizza-parlor-website' live='https://allwaypizza.netlify.app/' details='pizza parlor website using HTML, CSS, javaScript' />
          <Project title="Project 5" source='https://github.com/NamandeepNegi/blog-website-project' live='https://blogsreactjs.netlify.app/' details='Blog Website using React js' />

          {/* ROW 3 */}
          <Project title="Project 6" source='' live='' />
          <Project title="Project 7" source='' live='' />
          <div style={{ border: '2px solid black' }}
            className="flex justify-center text-center items-center p-10 bg-blue
              max-w-[403px] max-h-[480px] text-2xl font-playfair font-semibold"
          >
            SMOOTH USER EXPERIENCE
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Projects;
